import { FireComponent, FireHelpers } from '@base';

export class HeroCarousel extends FireComponent {
  constructor(id) {
    super(id);
  }

  get elements() {
    return {
      $items: this.$component.find('[data-hero-carousel-item]'),
    };
  }

  _updateMarkupOrder() {
    if (window.innerWidth < FireHelpers.breakpoints.lg) {
      this.elements.$items.map((index, item) => {
        const image = item.querySelector('[data-hero-carousel-image]');
        if (image) {
          item.prepend(image);
        }
      });
    } else {
      this.elements.$items.map((index, item) => {
        const image = item.querySelector('[data-hero-carousel-image]');
        if (image) {
          item.append(image);
        }
      });
    }
  }

  init() {
    if (this.componentExists) {
      this._updateMarkupOrder();

      // Listen for resize events
      let timeout;
      let self = this;
      let width = window.innerWidth;
      window.addEventListener(
        'resize',
        function (event) {
          // only handle resize if width has changed, not height
          if (width !== window.innerWidth) {
            width = window.innerWidth;
            // If there's a timer, cancel it
            if (timeout) {
              window.cancelAnimationFrame(timeout);
            }

            // Setup the new requestAnimationFrame()
            timeout = window.requestAnimationFrame(() => {
              self._updateMarkupOrder();
            });
          }
        },
        false
      );
    }
  }
}
